
const RymApp = window.App || {}
let _deviceInfo

RymApp.getDeviceInfo = async function () {
  if (_deviceInfo) return _deviceInfo
  if (RymApp.IS_ANYDOOR) {
    try {
      const deviceInfo = await RymApp.asyncCall('sendMessage', ['getDeviceInfo'])
      if (deviceInfo) {
        deviceInfo.sdkVersion = deviceInfo.anyDoorSdkVersion
        _deviceInfo = deviceInfo
      }
    } catch (e) {
      console.log(e)
    }
  } else {
    _deviceInfo = {
      deviceType: RymApp.IS_IOS ? 'ios' : 'android',
      appId: 'PA06600000000_01_WXQD'
    }
  }
  return _deviceInfo || {}
}

RymApp.track = function (event = '', label = '', pluginId = '', map = {}) {
  if (RymApp.IS_ANYDOOR) {
    RymApp.asyncCall('saveTalkingData', {
      label: label,
      event: event,
      pluginId: pluginId,
      map: {
        ...map,
      },
    });
  } else {
    // eslint-disable-next-line
    SKAPP && SKAPP.onEvent(event, label,
      {
        DataType: 'H5',
        RYMOSType: this.IS_IOS ? 'ios' : 'android',
        DeviceId: localStorage.getItem("__SK_cookieId") || '',
        ...map,
      });
  }
};

export default RymApp